const loginForm = document.querySelector('.login-form');
const recoverForm = document.querySelector('.recover-form');
if (loginForm && recoverForm) {
  const enableLogin = document.querySelector('.enable-login');
  const enableForgot = document.querySelector('.enable-forgot');

  if (enableLogin) {
    enableLogin.addEventListener('click', (event) => {
      event.preventDefault();
      loginForm.classList.remove('hide-form');
      recoverForm.classList.add('hide-form');
    });
  }

  if (enableForgot) {
    enableForgot.addEventListener('click', (event) => {
      event.preventDefault();
      loginForm.classList.add('hide-form');
      recoverForm.classList.remove('hide-form');
    });
  }
}

document.querySelectorAll('.edit-address-button').forEach((editButton) => {
  editButton.addEventListener('click', (event) => {
    event.preventDefault();
    const addressId = editButton.dataset.addressid;
    document.querySelectorAll('.address-edit-form').forEach((editFormDiv) => {
      if (editFormDiv.classList.contains('active-form') && editFormDiv.dataset.id !== addressId) {
        editFormDiv.classList.remove('active-form');
      }
    });
    const target = document.querySelector(`[data-id="${addressId}"]`);
    if (target) {
      target.classList.toggle('active-form');
    }
    const mainAdd = document.getElementsByClassName('main-add')[0];
    const newAddBtn = document.getElementsByClassName('new-add-btn')[0];
    const mainAddTitle = document.getElementsByClassName('main-add-top-title')[0];
    const billingAddress = document.getElementsByClassName('billing-address')[0];
    if (mainAdd) mainAdd.classList.add('d-none');
    if (newAddBtn) newAddBtn.classList.add('d-none');
    if (mainAddTitle) mainAddTitle.classList.add('d-none');
    if (billingAddress) billingAddress.classList.add('d-none');
  });
});

if (document.querySelector('#AddressCountryNew')) {
  new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
    hideElement: 'AddressProvinceContainerNew'
  });
  document.querySelectorAll('[data-address-country-select]').forEach((select) => {
    const formId = select.dataset.formId;
    new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
      hideElement: `AddressProvinceContainer_${formId}`
    });
  });
}

document.querySelectorAll('.destroy_button').forEach((destroyButton) => {
  destroyButton.addEventListener('click', () => {
    const destroyId = destroyButton.dataset.destroy;
    console.log(destroyId);
    Shopify.postLink(
      `/account/addresses/${destroyId}`,
      { 'parameters': { '_method': 'delete' } }
    );
  });
});

const accountLink = document.querySelector('.account-link');
if (accountLink) {
  accountLink.addEventListener('click', () => {
    const accountPage = document.querySelector('.account-page-active');
    const accountLeft = document.querySelector('.account-left');
    if (accountPage) accountPage.classList.add('active');
    if (accountLeft) accountLeft.style.display = 'none';
  });
}

const addAddress = document.querySelector('.add-address');
if (addAddress) {
  addAddress.addEventListener('click', () => {
    const addressForm = document.getElementById('address_form_new');
    if (addressForm) addressForm.classList.toggle('active-open-form');
    const mainAdd = document.getElementsByClassName('main-add')[0];
    const newAddBtn = document.getElementsByClassName('new-add-btn')[0];
    const mainAddTitle = document.getElementsByClassName('main-add-top-title')[0];
    const billingAddress = document.getElementsByClassName('billing-address')[0];
    if (mainAdd) mainAdd.classList.add('d-none');
    if (newAddBtn) newAddBtn.classList.add('d-none');
    if (mainAddTitle) mainAddTitle.classList.add('d-none');
    if (billingAddress) billingAddress.classList.add('d-none');
  });
}

const onReady = (fn) => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fn);
  } else {
    fn();
  }
};

onReady(() => {
  const genderInput = document.querySelector('.customer-field #gender');
  const tagHidden = document.querySelector('.tag-hidden');
  if (genderInput && tagHidden) {
    genderInput.addEventListener('change', (event) => {
      tagHidden.value = event.target.value;
    });
  }

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    const defUncheck = target.closest('.singal-add .def-uncheck');
    if (!defUncheck) return;

    const id = defUncheck.getAttribute('data-id-id');
    document.querySelectorAll('.address-form .address-edit-form').forEach((editForm) => {
      const nId = editForm.getAttribute('data-id');
      if (nId === id) {
        const checkbox = editForm.querySelector('input[type="checkbox"]');
        if (checkbox) checkbox.checked = true;
        const form = editForm.querySelector('form');
        if (form) {
          const submitEvent = new Event('submit', { bubbles: true, cancelable: true });
          if (form.dispatchEvent(submitEvent)) {
            if (typeof form.requestSubmit === 'function') {
              form.requestSubmit();
            } else {
              form.submit();
            }
          }
        }
      }
    });
  });

  const remember = document.getElementById('remember');
  const emailInput = document.getElementById('CustomerEmail');
  const passwordInput = document.getElementById('CustomerPassword');

  if (remember && emailInput && passwordInput) {
    if (localStorage.chkbx && localStorage.chkbx !== '') {
      remember.checked = true;
      emailInput.value = localStorage.usrname || '';
      passwordInput.value = localStorage.pass || '';
    } else {
      remember.checked = false;
      emailInput.value = '';
      passwordInput.value = '';
    }

    remember.addEventListener('click', () => {
      if (remember.checked) {
        localStorage.usrname = emailInput.value || '';
        localStorage.pass = passwordInput.value || '';
        localStorage.chkbx = remember.value || 'on';
      } else {
        localStorage.usrname = '';
        localStorage.pass = '';
        localStorage.chkbx = '';
      }
    });
  }
});

const passwordInput = document.getElementById('password');
const number = document.getElementById('number');
const length = document.getElementById('length');
const smbl = document.getElementById('smbl');

if (passwordInput && number && length && smbl) {
  passwordInput.addEventListener('keyup', () => {
    const numbers = /[0-9]/g;
    if (passwordInput.value.match(numbers)) {
      number.classList.remove('invalid');
      number.classList.add('valid');
    } else {
      number.classList.remove('valid');
      number.classList.add('invalid');
    }

    if (passwordInput.value.length >= 8) {
      length.classList.remove('invalid');
      length.classList.add('valid');
    } else {
      length.classList.remove('valid');
      length.classList.add('invalid');
    }

    const smbls = /[!@#$%^&*_=+-]/g;
    if (passwordInput.value.match(smbls)) {
      smbl.classList.remove('invalid');
      smbl.classList.add('valid');
    } else {
      smbl.classList.remove('valid');
      smbl.classList.add('invalid');
    }
  });
}
